import React, { useRef, useState } from "react";
import Loading from "../../../cross/Loading";
import ICurrentUser from "../../../entities/helper/ICurrentUser";
import { ICausaInmediata } from "../../../entities/ICausaInmediata";
import { ICausaSistema } from "../../../entities/ICausaSistema";
import { IDesviacion } from "../../../entities/IDesviacion";
import { usePromiseEffect } from "../../../helpers/promiseEffect";
import DesviacionService from "../../../services/DesviacionService";
import { CellContext, createColumnHelper } from "@tanstack/react-table";
import { ITipo_Campo } from "../../../helpers/IFormHelper";
import Swal, { SweetAlertResult } from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { dateFormatInputReference, shortDate } from "../../../helpers/dateHelper";
import IDocumentoDesviacion, {
  IAddDocumentosCausasEvidencias,
  IEvidenciasArbolCausal,
  ISearchDocsCausasEvidencias,
} from "../../../entities/IDocumentoDesviacion";
import { Col, Row } from "react-bootstrap";
import { getFileName } from "../../../helpers/pathHelper";
import { ETipoCausa } from "../../../enums/E_TipoCausa";
import { E_EstadoCausa } from "../../../enums/E_EstadoCausa";
import { ROW_COUNT, ROW_COUNT_MAX } from "../../../helpers/variableHelper";
import moment from "moment";
import { cognitoUserInfo } from "../../../helpers/userHelper";
import { AdminListaPagination, IPagination } from "../../../controls/AdminListaPagination";
import { items as desvitems } from "../../../test/variableTest";
import { ICausaBasica } from "../../../entities/ICausaBasica";
import RenderTitle from "../../../controls/RenderTitle";
import RenderValue from "../../../controls/RenderValue";
import { ETipoDesviacion } from "../../../enums/E_TipoDesviacion";
const MySwal = withReactContent(Swal);
interface IDesviacionRegistrarCierreProps {
  token: string;
  readonly?: boolean;
  loading?: boolean;
  items?: Array<IDocumentoDesviacion>;
  tp?: string;
  id?: string;
  is_Test?: boolean;
  items1?: Array<ICausaInmediata>;
  items2?: Array<ICausaBasica>;
  items3?: Array<ICausaSistema>;
}
export default function AccionesAsignadas({// NOSONAR "Se aplica en esta linea ya que SONAR nos arroja 83 como valor de complejidad cognitiva. Esta función realiza varias validaciones para la carga de las acciones, y para manejar las pruebas unitarias".
  token,
  readonly,
  loading = true,
  items,
  tp = "0",
  id = "0",
  is_Test,
}: IDesviacionRegistrarCierreProps) {
  let search = new URLSearchParams(window.location.search);
  const idDesviacion = parseInt(search.get("id") || id);
  const idCausa = parseInt(search.get("idCausa") || "0");
  const selectedTipoCausa: ETipoCausa = parseInt(search.get("tp") || tp);
  const [selectedDesviacion, setSelectedDesviacion] = useState<IDesviacion | null>(null);
  const [isLoading, setIsLoading] = useState(loading);

  const [currentUser, setCurrentUser] = useState<ICurrentUser>();
  const [selectedCausa, setSelectedCausa] = useState<ICausaBasica | ICausaInmediata | ICausaSistema | null>(null);
  const refTxtDescripcionDocumento = React.createRef<HTMLTextAreaElement>();
  const [lenTxtDescripcionDocumento, setLenTxtDescripcionDocumento] = useState(0);
  const refInputDocumento = React.createRef<HTMLInputElement>();
  const refInputFechaAccionRealizada = React.createRef<HTMLInputElement>();
  const [arrErrorEmpty, setArrErrorEmpty] = useState<Array<string>>([]);
  const [isSendingData, setIsSendingData] = useState(false);
  const [isUploadingDocs, setIsUploadingDocs] = useState(false);
  const [listDocumentos, setListDocumentos] = useState<Array<IDocumentoDesviacion>>(items || []);
  const [isReadOnly] = useState(readonly);
  const totalPagesListPlanAccion = useRef<number>(0);

  const component = (titulo: string) => {
    return <RenderTitle title={titulo} />;
  };

  const componentValue = (value: any) => {
    return <RenderValue value={value} />;
  };

  const componentVer = (value: any) => {
    return (
      <i
        className="bi bi-search iconSearch"
        title="Ver Desviación"
        onClick={() => {
          DesviacionService.getContenidoDocumentoAnalisCausal(token, value.row.original.URL);
        }}></i>
    );
  };

  const componentEliminar = (value: any) => {
    return (
      <i
        className="bi bi-trash iconSearch"
        title="Ver Desviación"
        onClick={() => {
          MySwal.fire({
            text: `¿Está seguro que desea eliminar el documento?`,
            icon: "question",
            confirmButtonText: "Aceptar",
            cancelButtonText: "Cancelar",
            showCloseButton: true,
            showCancelButton: true,
          }).then(async (result: SweetAlertResult) => {
            if (result.isConfirmed) {
              await DesviacionService.deleteDocumentoCausaEvidencia(token, value.row.original.ID as number);
              await refreshTableDocumentos();
            }
          });
        }}></i>
    );
  };

  usePromiseEffect(async () => {
    let currUser = await cognitoUserInfo();
    setCurrentUser(currUser);

    if (idDesviacion) {
      let resultDesviacion = is_Test ? desvitems[0] : await DesviacionService.getDesvicacionByID(token, idDesviacion);
      setSelectedDesviacion(resultDesviacion);

      let paramActive = {
        ORDENADOPOR: "ID",
        ORIENTACION: "DESC",
        PAGINA: 1,
        PAGINADO: ROW_COUNT_MAX,
      };
      let c: ICausaInmediata | ICausaBasica | ICausaSistema | null = null;
      if (selectedTipoCausa === ETipoCausa.Inmediata) {
        let listI = await DesviacionService.getListadoCausaInmediata(token, {
          ID: idDesviacion,
          ...paramActive,
        });
        c = listI?.data.filter((i) => i.ID === idCausa).shift() || null;
        setSelectedCausa(c);
      } else if (selectedTipoCausa === ETipoCausa.Basica) {
        let listB = await DesviacionService.getListadoCausaBasica(token, {
          ID: idDesviacion,
          ...paramActive,
        });
        c = listB.data.filter((b) => b.ID === idCausa).shift() || null;
        setSelectedCausa(c);
      } else {
        let listS = await DesviacionService.getListadoCausaSistema(token, {
          ID: idDesviacion,
          ...paramActive,
        });
        c = listS?.data.filter((s) => s.ID === idCausa).shift() || null;
        setSelectedCausa(c);
        console.log(c);
      }

      refreshTableDocumentos();
      setIsLoading(false);
    }
  }, []);

  const refreshTableDocumentos = async (pagination?: IPagination) => {
    let params: ISearchDocsCausasEvidencias = pagination
      ? {
          ...pagination,
          ID_DESVIACION: idDesviacion,
          ID_CAUSA: idCausa,
        }
      : {
          ID_DESVIACION: idDesviacion,
          ID_CAUSA: idCausa,
          ORDENADOPOR: "ID",
          ORIENTACION: "DESC",
          PAGINA: 1,
          PAGINADO: ROW_COUNT,
        };
    let resultDocumentos = is_Test ? { data: items ?? [], pages: 10 } : await DesviacionService.getDocumentosCausasEvidencias(token, params);
    setListDocumentos(resultDocumentos.data);
    totalPagesListPlanAccion.current = resultDocumentos.pages;
  };

  const validateAccionRealizada = (accionRealizada: boolean) => {
    const arrErrors: Array<string> = [];
    let msjError: Array<string> = [];
    if (!moment(refInputFechaAccionRealizada.current?.value).isValid()) {
      arrErrors.push("FECHA_ACCION_REALIZADA");
      msjError.push(`Seleccione una fecha de acción realizada. \n`);
    }
    if (listDocumentos.length === 0) {
      arrErrors.push("LISTA_EVIDENCIA");
      msjError.push(`Debe ingresar al menos una evidencia. \n`);
    }
    if (accionRealizada && arrErrors.length > 0) {
      MySwal.fire({
        html: (
          <div>
            <p>
              <strong>Error Ingreso de datos:</strong>
            </p>
            {msjError.map((me) => (
              <p key={me}>{me}</p>
            ))}
          </div>
        ),
        icon: "warning",
        confirmButtonText: "Aceptar",
        showCloseButton: true,
      });
    }
    setArrErrorEmpty(arrErrors);
    return arrErrors.length === 0;
  };
  const handleGuardarAccion = async (cambioEstado?: boolean) => {
    if (cambioEstado && !validateAccionRealizada(cambioEstado)) {
      return false;
    }
    if (selectedTipoCausa === ETipoCausa.Inmediata) {
      setIsSendingData(true);
      await DesviacionService.postGuardarAccionCausaInmediata(token, {
        EDITOR: currentUser?.email as string,
        EDITOR_DISPLAY: currentUser?.fullname as string,
        ID_DESVIACION: idDesviacion,
        ID: selectedCausa?.ID as number,
        ID_ESTADO: E_EstadoCausa.AccionRealizada,
        ACCION_REALIZADA: true,
        FECHA_ACCION_REALIZADA: new Date(refInputFechaAccionRealizada.current?.value as string),
      });
    } else if (selectedTipoCausa === ETipoCausa.Basica) {
      setIsSendingData(true);
      await DesviacionService.postGuardarAccionCausaBasica(token, {
        EDITOR: currentUser?.email as string,
        EDITOR_DISPLAY: currentUser?.fullname as string,
        ID_DESVIACION: idDesviacion,
        ID: selectedCausa?.ID as number,
        ID_ESTADO: E_EstadoCausa.AccionRealizada,
        ACCION_REALIZADA: true,
        FECHA_ACCION_REALIZADA: new Date(refInputFechaAccionRealizada.current?.value as string),
      });
    } else {
      let fechaAccionRealizada = new Date(refInputFechaAccionRealizada.current?.value as string);
      setIsSendingData(true);
      await DesviacionService.postGuardarAccionCausaSistema(token, {
        EDITOR: currentUser?.email as string,
        EDITOR_DISPLAY: currentUser?.fullname as string,
        ID_DESVIACION: idDesviacion,
        ID: selectedCausa?.ID as number,
        ID_ESTADO: E_EstadoCausa.AccionRealizada,
        ACCION_REALIZADA: true,
        FECHA_ACCION_REALIZADA: fechaAccionRealizada,
        REQUIERE_CAMBIO_ESTADO: cambioEstado,
      });
    }
    if (cambioEstado && validateAccionRealizada(cambioEstado)) {
      window.location.href = "/desviacion";
    } else if (!cambioEstado) {
      setIsSendingData(false);
    }
  };

  const validateUploadFile = (value: Partial<IDocumentoDesviacion>) => {
    let arrErrors: Array<string> = [];

    if (!refInputDocumento.current?.files) {
      arrErrors.push("ARCHIVO");
    } else {
      if (listDocumentos.filter((d) => d.URL.includes((refInputDocumento.current?.files as FileList)[0].name)).length > 0) {
        arrErrors.push("ARCHIVO_DUPLICADO");

        MySwal.fire({
          html: (
            <div>
              <h3>Archivo "{(refInputDocumento.current?.files)[0].name}" ya se encuentra cargado</h3>
            </div>
          ),
          text: "",
          icon: "error",
          showCloseButton: true,
        });
      }
    }
    return arrErrors.length === 0;
  };

  const handleUploadDocument = async () => {
    let f = (refInputDocumento.current?.files as FileList)[0] as any;
    let tipoCausa = "";
    if (selectedTipoCausa === ETipoCausa.Inmediata) {
      tipoCausa = "Inmediata";
    } else if (selectedTipoCausa === ETipoCausa.Basica) {
      tipoCausa = "Basica";
    } else {
      tipoCausa = "Sistema";
    }
    let value: Partial<IAddDocumentosCausasEvidencias> = {
      TIPO_CAUSA: tipoCausa,
      ID_DESVIACION: selectedDesviacion?.ID as number,
      DESCRIPCION: refTxtDescripcionDocumento.current?.value,
      FILE: f,
      ID_CAUSA: idCausa,
    };
    if (validateUploadFile(value)) {
      setIsUploadingDocs(true);
      await DesviacionService.postDocumentoCausaEvidencia(token, value);
      setLenTxtDescripcionDocumento(0);
      refreshTableDocumentos();
      setIsUploadingDocs(false);
    }
  };

  const columnHelperEvidenciasCargadas = createColumnHelper<IEvidenciasArbolCausal>();
  let columnsDefPlanAccion = [
    columnHelperEvidenciasCargadas.accessor((row) => row.URL, {
      id: "URL",
      cell: (info: CellContext<IEvidenciasArbolCausal, string>) => componentValue(getFileName(info.getValue())),
      header: () => component("Nombre Documento"),
      tipo: ITipo_Campo.text,
    } as any),
    columnHelperEvidenciasCargadas.accessor((row) => row.DESCRIPCION, {
      id: "DESCRIPCION",
      cell: (info: CellContext<IEvidenciasArbolCausal, string>) => componentValue(info.getValue()),
      header: () => component("Descripción"),
      tipo: ITipo_Campo.text,
    } as any),
    columnHelperEvidenciasCargadas.accessor((row) => row.ID, {
      id: "VER",
      cell: (info: CellContext<IEvidenciasArbolCausal, string>) => componentVer(info),
      header: () => component("Ver"),
      tipo: ITipo_Campo.text,
      disableSorting: true,
    } as any),
    columnHelperEvidenciasCargadas.accessor((row) => row.ID, {
      id: "ELIMINAR",
      cell: (info: CellContext<IDesviacion, string>) => componentEliminar(info),
      header: () => component("Eliminar"),
      tipo: ITipo_Campo.text,
      disableSorting: true,
      hide: isReadOnly,
    } as any),
  ] as any;

  return isLoading ? (
    <>
      <Loading />-
    </>
  ) : (
    <div className="">
      <div className="container-fluid mb-4">
        <button
          hidden={true}
          data-testid="btnvalidate"
          onClick={() => {
            validateAccionRealizada(true);
          }}></button>
        <div id="form">
          {selectedTipoCausa === ETipoCausa.Inmediata && (
            <React.Fragment>
              <Row>
                <Col>
                  <div className="row mb-2 ajusteInput">
                    <Col xs="12" md="6" lg="4">
                      <label>Tipo de Causas Inmediatas:</label>
                    </Col>
                    <Col xs="12" md="6" lg="8">
                      <span>{(selectedCausa as ICausaInmediata)?.TIPO_CAUSA_INMEDIATA}</span>
                    </Col>
                  </div>
                </Col>
              </Row>
              <Row>
                <Col>
                  <div className="row mb-2 ajusteInput">
                    <Col xs="12" md="6" lg="4">
                      <label>Acto/Condición subestandar:</label>
                    </Col>
                    <Col xs="12" md="6" lg="8">
                      <span>{(selectedCausa as ICausaInmediata)?.ACTO_CONDICION_SUBESTANDAR}</span>
                    </Col>
                  </div>
                </Col>
              </Row>
            </React.Fragment>
          )}
          {selectedTipoCausa === ETipoCausa.Basica && (
            <React.Fragment>
              <Row>
                <Col>
                  <div className="row mb-2 ajusteInput">
                    <Col xs="12" md="6" lg="4">
                      <label>Tipo de Causas Básicas:</label>
                    </Col>
                    <Col xs="12" md="6" lg="8">
                      <span>{(selectedCausa as ICausaBasica)?.TIPO_CAUSA_BASICA}</span>
                    </Col>
                  </div>
                </Col>
              </Row>
              <Row>
                <Col>
                  <div className="row mb-2 ajusteInput">
                    <Col xs="12" md="6" lg="4">
                      <label>Factores Personales o del Trabajo:</label>
                    </Col>
                    <Col xs="12" md="6" lg="8">
                      <span>{(selectedCausa as ICausaBasica)?.FACTORES_PERSONALES}</span>
                    </Col>
                  </div>
                </Col>
              </Row>
              <Row>
                <Col>
                  <div className="row mb-2 ajusteInput">
                    <Col xs="12" md="6" lg="4">
                      <label>Descripción de la Causa:</label>
                    </Col>
                    <Col xs="12" md="6" lg="8">
                      <span>{(selectedCausa as ICausaBasica)?.CAPACIDADES}</span>
                    </Col>
                  </div>
                </Col>
              </Row>
            </React.Fragment>
          )}
          {selectedTipoCausa === ETipoCausa.Sistema && (
            <React.Fragment>
              <Row>
                <Col>
                  <div className="row mb-2 ajusteInput">
                    <Col xs="12" md="6" lg="4">
                      <label>Tipo Ámbito de Gestión:</label>
                    </Col>
                    <Col xs="12" md="6" lg="8">
                      <span>{(selectedCausa as ICausaSistema)?.REQUISITOS}</span>
                    </Col>
                  </div>
                </Col>
              </Row>
              <Row>
                <Col>
                  <div className="row mb-2 ajusteInput">
                    <Col xs="12" md="6" lg="4">
                      <label>Descripción del Ámbito de Gestión:</label>
                    </Col>
                    <Col xs="12" md="6" lg="8">
                      <span>{(selectedCausa as ICausaSistema)?.REQUISITO_SISTEMA}</span>
                    </Col>
                  </div>
                </Col>
              </Row>
            </React.Fragment>
          )}

          <Row>
            <Col>
              <div className="row mb-2 ajusteInput">
                <Col xs="12" md="6" lg="4">
                  <label>Acción:</label>
                </Col>
                <Col xs="12" md="6" lg="8">
                  <span>{(selectedCausa as ICausaBasica)?.ACCION}</span>
                </Col>
              </div>
            </Col>
          </Row>
          <Row>
            <Col>
              <div className="row mb-2 ajusteInput">
                <Col xs="12" md="6" lg="4">
                  <label>Responsable:</label>
                </Col>
                <Col xs="12" md="6" lg="8">
                  <span>{(selectedCausa as ICausaBasica)?.RESPONSABLE_DISPLAY}</span>
                </Col>
              </div>
            </Col>
          </Row>
          <Row>
            <Col>
              <div className="row mb-2 ajusteInput">
                <Col xs="12" md="6" lg="4">
                  <label>Fecha de asignación:</label>
                </Col>
                <Col xs="12" md="6" lg="8">
                  <span>{shortDate((selectedCausa as ICausaBasica)?.FECHA_ASIGNACION)}</span>
                </Col>
              </div>
            </Col>
          </Row>
          <Row>
            <Col>
              <div className="row mb-2 ajusteInput">
                <Col xs="12" md="6" lg="4">
                  <label>Fecha hasta:</label>
                </Col>
                <Col xs="12" md="6" lg="8">
                  <span>{shortDate((selectedCausa as ICausaBasica)?.FECHA_HASTA)}</span>
                </Col>
              </div>
            </Col>
          </Row>
          <Row>
            <Col>
              <div className="row mb-2 ajusteInput">
                <Col xs="12" md="6" lg="4">
                  <span className="text-danger">
                    <strong>(*)</strong>
                  </span>

                  <label>Fecha Acción Realizada:</label>
                </Col>
                <Col xs="12" md="6" lg="8">
                  <input
                    type="date"
                    ref={refInputFechaAccionRealizada}
                    className={`form-control ${arrErrorEmpty.includes("FECHA_ACCION_REALIZADA") && "error"}`}
                    max={moment().format(dateFormatInputReference)}
                    defaultValue={selectedCausa ? (shortDate(selectedCausa?.FECHA_ACCION_REALIZADA, dateFormatInputReference) as string) : ""}
                    disabled={isReadOnly}
                  />
                </Col>
              </div>
            </Col>
          </Row>
          {selectedCausa?.ID_ESTADO === E_EstadoCausa.Rechazada ? (
            <Row>
              <Col>
                <div className="row mb-2 ajusteInput">
                  <Col xs="12" md="6" lg="4">
                    <label>Motivo rechazo:</label>
                  </Col>
                  <Col xs="12" md="6" lg="8">
                    <span>{selectedCausa.MOTIVO_RECHAZO}</span>
                  </Col>
                </div>
              </Col>
            </Row>
          ) : (
            <></>
          )}
          <React.Fragment>
            <Row>
              <div className="card bg-light border p-3 pt-2 mt-2">
                <div className="row ajusteInput">
                  <div className="col-12">
                    <h6>
                      <span className="textSeccion">Adjuntar Evidencia</span>
                    </h6>
                  </div>
                  <div className="col-12">
                    {!isReadOnly &&
                      (isUploadingDocs ? (
                        <Loading />
                      ) : (
                        <div className="row mb-2 ajusteInput">
                          <div className="row border m-1 p-1 rounded">
                            <div className="col-sm-12 col-md-12 col-lg-5 mb-2">
                              <label>Descripción</label>
                            </div>
                            <div className="col-sm-12 col-md-12 col-lg-7 mb-2">
                              <textarea
                                className="form-control form-control-sm"
                                data-testId="textarea"
                                rows={3}
                                ref={refTxtDescripcionDocumento}
                                maxLength={250}
                                onChange={(e) => {
                                  setLenTxtDescripcionDocumento(e.target.value.length);
                                }}></textarea>
                              <span>{lenTxtDescripcionDocumento}/250</span>
                            </div>
                            <div className="col-sm-12 col-md-12 col-lg-5 mb-2">
                              <label>Adjuntar </label>
                              <span className="text-danger">
                                <small> Peso máximo (50 mb).</small>
                              </span>
                            </div>
                            <div className="col-sm-12 col-md-12 col-lg-7 mb-2">
                              <div className="input-group">
                                <input
                                  type="file"
                                  className="form-control form-control-sm"
                                  id="inputGroupFile04"
                                  aria-describedby="inputGroupFileAddon04"
                                  aria-label="Seleccionar Archivos"
                                  ref={refInputDocumento}
                                />
                                {isUploadingDocs ? (
                                  <Loading />
                                ) : (
                                  <button
                                    className="btn btn-primary btn-sm"
                                    type="button"
                                    id="inputGroupFileAddon04"
                                    onClick={() => {
                                      handleUploadDocument();
                                    }}
                                    disabled={isUploadingDocs}>
                                    Subir
                                  </button>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      ))}
                    <AdminListaPagination
                      defaultSortBy="ID"
                      sortDirection="DESC"
                      totalPages={totalPagesListPlanAccion}
                      callback={(pagination) => {
                        refreshTableDocumentos(pagination);
                      }}
                      reload={() => {
                        refreshTableDocumentos();
                      }}
                      columnsDef={columnsDefPlanAccion}
                      data={listDocumentos}
                      hideAdd={true}
                      hideExport={true}
                    />
                  </div>
                </div>
              </div>
            </Row>
          </React.Fragment>
          {isSendingData ? (
            <Loading />
          ) : (
            <Row>
              <div className="col-sm-12 col-md-12 col-lg-12 mt-3">
                {!isReadOnly && (
                  <span>
                    <button
                      type="button"
                      className="btn btn-sm btn-primary me-2"
                      onClick={() => {
                        handleGuardarAccion();
                      }}
                      disabled={isSendingData}>
                      <i className="bi bi-arrow-left-circle me-2"></i> Guardar
                    </button>
                    <button
                      type="button"
                      className="btn btn-sm btn-primary me-2"
                      onClick={() => {
                        handleGuardarAccion(true);
                      }}
                      disabled={isSendingData}>
                      <i className="bi bi-arrow-left-circle me-2"></i>Acción Realizada
                    </button>
                  </span>
                )}
                <button
                  type="button"
                  className="btn btn-sm btn-primary me-2"
                  onClick={() => {
                    window.location.href = "/desviacion";
                  }}
                  disabled={isSendingData}>
                  <i className="bi bi-arrow-left-circle me-2"></i> Volver
                </button>
              </div>
            </Row>
          )}
        </div>
      </div>
    </div>
  );
}
